import { render, staticRenderFns } from "./HeaderNavBack.vue?vue&type=template&id=b779bde0&lang=html"
import script from "./HeaderNavBack.vue?vue&type=script&lang=js"
export * from "./HeaderNavBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports